<!--
 * @FileDescription: 参考资料上传组件
 * @Author: wh
 * @Date: 2021-01-11 14:03:34
 * @LastEditors: wh
 * @LastEditTime: 2021-01-11 15:03:52
-->
<template>
  <yxt-form-item :label="label || $t('pc_ulcd_lbl_attachmentfile')" prop="files">
    <yxtbiz-upload
      ref="bizUpload"
      config-key="AttachConfigKey"
      :module-name="appCode"
      :app-code="appCode"
      :function-name="appCode"
      :filters="filterType"
      :on-ready="onReady"
      :before-upload="beforeUpload"
      :on-progress="onProgress"
      :on-uploaded="onUploaded"
      :on-error="onError"
      :on-complete="onComplete"
      :disabled="disabled"
      :files-added='fileAdded'
    >
      <!-- 上传文件 -->
      <yxt-button v-if="buttonType" icon="yxt-icon-upload2" plain :disabled="disabled" :type="buttonType">{{ $t('pc_ulcd_btn_uploadfile') }}</yxt-button>
      <yxt-button v-else icon="yxt-icon-upload2" plain :disabled="disabled">{{ $t('pc_ulcd_btn_uploadfile') }}</yxt-button>
    </yxtbiz-upload>
    <slot v-if="$slots.toolTip" name="toolTip">
      <div class="c-bf">{{ $t('pc_ulcd_msg_filemessage') }}</div>
    </slot>
    <div v-else class="c-bf">{{ $t('pc_ulcd_msg_filemessage') }}</div>
    <ul>
      <li v-for="file of files" :key="file.fileId" class="pv12 border-l2b">
        <span class="d-in-block has-del-icon v-mid nowrap ellipsis">{{ file.name }}</span>
        <ulcd-svg class="v-mid hand c-bf v-mid ml16 hover-primary-6" back name='close' width='20px' height='20px' @click.native="removeFile(file)" />
        <yxt-progress v-if="file.percentage !== 100" :percentage="file.percentage" class="pa pa-l-b fit-w" />
      </li>
    </ul>
  </yxt-form-item>
</template>

<script>
import mixin from '../mixin/file-upload.js';
export default {
  name: 'uploadRefs', // uploadReferences
  mixins: [mixin],
  props: {
    limit: { type: Number, default: 0 },
    appCode: String, // o2o、kng...
    files: {
      type: Array,
      default: () => []
    },
    label: { type: String, default: '' },
    buttonType: {
      type: String,
      default: ''
    }
  },
  computed: {
    disabled() {
      return this.limit !== 0 && this.files.length >= this.limit;
    }
  }
};
</script>
